import { verticalCopyContentSelector, verticalLinkContentSelector, verticalMediaContentSelector } from './brand_content';

/*
FYI the below methods are used as selectors in the JSON schema context
This is why they have to be written with an object wrapping ({ state }) as the first argument
If you are writing a selector that is not used in the JSON schema context, you should write it as a normal function in a seperate file
*/
export const footerCopyrightBannerBrandName = ({ state }) => verticalCopyContentSelector(state).get('footer_copyright_banner_brand_name');

export const footerCopyrightPrivacyPolicyUrl = ({ state }) => verticalLinkContentSelector(state).get('footer_copyright_banner_privacy_policy_url');

export const footerCopyrightTermsOfUseUrl = ({ state }) => verticalLinkContentSelector(state).get('footer_copyright_banner_terms_of_use_url');

export const regoLookupWelcomeMessage = ({ state }) => verticalCopyContentSelector(state).get('rego_lookup_welcome_message');
